import classNames from "classnames";

export interface FooterProps {
  children: React.ReactNode;
  className?: string;
}

export const Footer = ({ children, className, ...rest }: FooterProps) => (
  <footer
    className={classNames(
      "bg-primary border-primary grid-in-footer size-full overflow-x-auto border-t",
      className,
    )}
    {...rest}
  >
    {children}
  </footer>
);
